import classNames from "classnames";
import { FunctionComponent, memo } from "react";

import AnomalyProportionChange from "./anomaly-proportion-change";
import AnomalyProportionBarLabel from "./anomaly-proportion-bar-label";
import { IProps } from "./anomaly-proportion-bar.types";
import "./anomaly-proportion-bar.scss";

/**
 * For some item (a tag, phrase etc.) show what proportion of all interactions match/contain it, and how much that has
 * changed recently.
 * @param props.label             Name of the item.
 * @param props.isSelected        Users can select the items to filter sample interactions.
 * @param props.onToggle          Handler for a user clicks an item.
 * @param props.proportion        Percentage of how much of the total interactions this item accounts for.
 * @param props.proportionChange  How much of the percentage of total interactions the item has increased or descreased.
 * @param props.interactionsCount Total number of interactions matching the item.
 * @returns
 */
const AnomalyProportionBar: FunctionComponent<IProps> = ({
    label: { id, label },
    isSelected,
    onToggle,
    proportion,
    proportionChange,
    interactionsCount,
}) => {
    // Ensure the proportion width will not overflow
    const proportionBarWidth = Math.min(Math.max(proportion * 100, 0), 100);

    return (
        <div
            className={classNames("anomaly-proportion-bar", {
                "anomaly-proportion-bar--is-selected": isSelected,
            })}
        >
            <label htmlFor={label}>
                <input id={label} onChange={() => onToggle(id)} type="checkbox" />

                <div className="anomaly-proportion-bar__bar-container">
                    <div className="anomaly-proportion-bar__bar" style={{ width: `${proportionBarWidth}%` }}></div>
                </div>
            </label>

            <AnomalyProportionBarLabel label={label} />

            <label htmlFor={label} className="anomaly-proportion-bar__count">
                {interactionsCount.toLocaleString()}
            </label>

            <label>
                <AnomalyProportionChange proportionChange={proportionChange} />
            </label>
        </div>
    );
};

export default memo(AnomalyProportionBar);
